import {
  Box,
  Button,
  Grid,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import { backend } from "../../../api";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useHistory } from "react-router";
import React from "react";
import { customerFormSchema } from "./signUpFormSchema";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
// import PhoneInput from 'react-phone-number-input'
// import 'react-phone-number-input/style.css'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "20px 0",
    margin: "15px 0",
  },
  formHeading: {
    fontWeight: "550",
    width: "90%",
    margin: "10px auto",
  },
  form: {
    margin: "20px auto",
    width: "90%",
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "5px",
    width: "100%",
  },
  btn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "10px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  roleItem: {
    padding: "10px 10px",
    cursor: "pointer",
  },
}));

function CustomerForm() {
  const classes = useStyles();
  const history = useHistory();
  const handleFormSubmit = (values) => {
    // console.log({'Form values': values})
    const newUser = {
      name: values.name,
      email: values.email,
      role: "customer",
      password: values.password,
      phone: values.contact,
      address: {
        name: values.street,
        city: values.city,
        state: values.state,
        country: values.country,
        zip: values.zip,
      },
    };
    backend
      .post("/customer/create", newUser)
      .then((res) => {
        Swal.fire({
          title: "Congratulations",
          icon: "success",
          confirmButtonText: "OK",
          text: res.data.message,
        }).then((result) => {
          if (result.isConfirmed) {
            history.push("/login");
          }
        });
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  return (
    <div>
      <h2 className={classes.formHeading}>Create Account as Customer</h2>
      <Formik
        initialValues={{
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
          contact: "",
          country: "",
          state: "",
          city: "",
          street: "",
          zip: "",
        }}
        onSubmit={(values) => handleFormSubmit(values)}
        validationSchema={customerFormSchema}
      >
        {({ errors, values, handleChange, setValues, setFieldValue }) => {
          return (
            <Form className={classes.form}>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Name</InputLabel>
                <Field
                  type="text"
                  name="name"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.name}
                  className={classes.inputField}
                />
                <ErrorMessage name="name">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Email</InputLabel>
                <Field
                  type="email"
                  name="email"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.email}
                  className={classes.inputField}
                />
                <ErrorMessage name="email">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>
                  Contact No.
                </InputLabel>
                {/* <Field type="text" name="contact" as={OutlinedInput} fullWidth error={errors.contact} className={classes.inputField} /> */}
                {/* <PhoneInput
                                    placeholder="Enter Phone Number"
                                    name="contact"
                                    value={values.contact}
                                    // className={classes.inputField}
                                    onChange={(e) => {
                                        // handleChange(e)
                                        setFieldValue('contact', e)
                                        // console.log(_)
                                    }}
                                /> */}
                <PhoneInput
                  value={values.contact}
                  type="text"
                  name="contact"
                  className={classes.inputField}
                  inputProps={{
                    name: "contact",
                    required: true,
                    autoFocus: true,
                  }}
                  onChange={(value, country, e, formattedValue) => {
                    // handleChange(value)
                    setFieldValue("contact", value);
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                  inputStyle={{
                    width: "100%",
                    padding: "20px 40px",
                  }}
                />
                <ErrorMessage name="contact">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputLabel className={classes.fieldLabel}>
                      Country
                    </InputLabel>
                    <CountryDropdown
                      name="country"
                      valueType="short"
                      className={classes.inputField}
                      value={values.country}
                      onChange={(_, e) => {
                        handleChange(e);
                      }}
                    />
                    <ErrorMessage name="country">
                      {(error) => (
                        <Typography variant="subtitle2" color="error">
                          {error}
                        </Typography>
                      )}
                    </ErrorMessage>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel className={classes.fieldLabel}>
                      State
                    </InputLabel>
                    <RegionDropdown
                      className={classes.inputField}
                      name="state"
                      countryValueType="short"
                      country={values.country}
                      value={values.state}
                      onChange={(_, e) => handleChange(e)}
                      error={errors.state}
                    />
                    <ErrorMessage name="state">
                      {(error) => (
                        <Typography variant="subtitle2" color="error">
                          {error}
                        </Typography>
                      )}
                    </ErrorMessage>
                  </Grid>
                </Grid>
              </Box>
              <Box mb={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputLabel className={classes.fieldLabel}>City</InputLabel>
                    <Field
                      type="text"
                      name="city"
                      as={OutlinedInput}
                      fullWidth
                      error={errors.city}
                      className={classes.inputField}
                    />
                    <ErrorMessage name="city">
                      {(error) => (
                        <Typography variant="subtitle2" color="error">
                          {error}
                        </Typography>
                      )}
                    </ErrorMessage>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel className={classes.fieldLabel}>
                      ZIP Code
                    </InputLabel>
                    <Field
                      type="number"
                      name="zip"
                      as={OutlinedInput}
                      fullWidth
                      error={errors.zip}
                      className={classes.inputField}
                    />
                    <ErrorMessage name="zip">
                      {(error) => (
                        <Typography variant="subtitle2" color="error">
                          {error}
                        </Typography>
                      )}
                    </ErrorMessage>
                  </Grid>
                </Grid>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>
                  Street Address
                </InputLabel>
                <Field
                  type="text"
                  name="street"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.street}
                  className={classes.inputField}
                />
                <ErrorMessage name="street">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Password</InputLabel>
                <Field
                  type="password"
                  name="password"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.password}
                  className={classes.inputField}
                />
                <ErrorMessage name="password">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>
                  Confirm Password
                </InputLabel>
                <Field
                  type="password"
                  name="confirmPassword"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.confirmPassword}
                  className={classes.inputField}
                />
                <ErrorMessage name="confirmPassword">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box align="right">
                <Button type="submit" className={classes.btn}>
                  Sign Up
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default CustomerForm;
